import React, { useEffect, useState, useRef } from "react";
import callApi from "../services/apiService";
import MessageCenterTable from "./MessageCenterTable";
import { MessageCenterTableItem } from "../Models/MessageCenterTableItem";

const ListCategoryItems: React.FC<{ category: string }> = ({ category }) => {
  const [items, setItems] = useState<MessageCenterTableItem[]>();

  const [loading, setLoading] = useState(true);
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) {
      return;
    }
    effectRan.current = true;

    const fetchSiteList = async () => {
      try {
        const items: MessageCenterTableItem[] =
          await callApi.getMessageCenterItemsByCategory(category);
        setItems(items);

        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch site list:", error);
      }
    };

    fetchSiteList();
  }, [category]);

  return (
    <>
      {!loading && <MessageCenterTable items={items || []} />}

      {loading && <p>Loading...</p>}

      {!loading && items?.length === 0 && (
        <>
          <h3>
            There aren't any Message Center items for this category at this
            time, or the category is invalid.
          </h3>
        </>
      )}
    </>
  );
};

export default ListCategoryItems;
